import type { TypographySlot } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/look-types';

/**
 * Brand-specific classes for the login and reset-password forms. Defaults are Cava.
 * Brand wrappers (components/commercetools-ui/organisms/authentication/*) pass their look to the shared forms.
 */
export type AuthLook = {
  inputClassName: string;
  rememberRowClassName: string;
  submitClassName: string;
  forgotPasswordClassName: string;
  resetTitleClassName: string;
  resetTitleFontFamily: TypographySlot['fontFamily'];
  resetSubmitClassName: string;
};

export const CAVA_AUTH_LOOK: AuthLook = {
  inputClassName: 'mb-16 h-50 w-260 rounded-md border border-gray-500 text-center text-base leading-6',
  rememberRowClassName: 'mb-30 flex items-center justify-between text-center leading-6',
  submitClassName: 'mb-16 text-center text-19 md:mb-20 uppercase',
  forgotPasswordClassName: 'cursor-pointer underline underline-offset-4 md:text-14 text-primary-regular',
  resetTitleClassName: 'mb-16 text-28',
  resetTitleFontFamily: 'primaryRegular',
  resetSubmitClassName: 'mb-16 text-19 leading-tight md:mb-20 uppercase',
};

export const PANDA_AUTH_LOOK: AuthLook = {
  ...CAVA_AUTH_LOOK,
  submitClassName: 'mb-16 rounded-lg text-center text-19 md:mb-20',
  forgotPasswordClassName: 'cursor-pointer underline underline-offset-4 md:text-14',
  resetTitleClassName: 'mb-16 text-16 md:mb-24 md:text-20 lg:text-24',
  resetTitleFontFamily: 'NunitoSansSemiBold',
  resetSubmitClassName: 'mb-16 text-16 leading-tight md:mb-20',
};

export const CHIPOTLE_AUTH_LOOK: AuthLook = PANDA_AUTH_LOOK;

export const LOOM_AUTH_LOOK: AuthLook = {
  inputClassName: 'mb-16 h-50 w-260 rounded-md border border-gray-500 text-center leading-6',
  rememberRowClassName: 'mb-30 flex items-center justify-between text-center text-base font-bold leading-6',
  submitClassName: 'mb-16 text-center text-lg font-semibold leading-tight tracking-wide md:mb-20',
  forgotPasswordClassName: 'cursor-pointer text-primary-regular hover:underline md:text-14',
  resetTitleClassName: 'mb-16 text-16 md:mb-24 md:text-20 lg:text-24',
  resetTitleFontFamily: 'secondaryBold',
  resetSubmitClassName: 'mb-16 text-16 leading-tight md:mb-20',
};
